import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import { getAxiosCancelToken } from "../../utils/getAxiosCancelToken";

let cancelToken;
const eventGetPublishedByOthers = (searchText, pageNumber, pageSize) => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.EVENTS.GET_CLASS_BY_STATUS(
      "PublishedByothers",
      searchText,
      pageNumber,
      pageSize,
      "withvtlt",
    ),
    "",
    cancelToken
  );
};

export default eventGetPublishedByOthers;
